import BaseModelAPI from '../BaseModelAPI';

export default class ReceiptFromProductionCaseSource extends BaseModelAPI {
	static entity = 'receiptfromproductioncasesource';
	static entityName = 'receiptfromproductioncasesource';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.receiptFromProductionCaseId = '';
			this.receiptFromProductionCase = {};
			this.receiptFromProductionMaterialId = '';
			this.receiptFromProductionMaterial = {};
			this.partId = '';
			this.part = {};
			this.qtyBefore = 0;
			this.qtyAfter = 0;
			this.qtyTaken = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}